export default function(instance) {
  return {
    getDishes(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/cafe/dishes/admin/", { params: data });
    },
    createDish(data) {
      return instance.post("/api/cafe/dishes/admin/", {
        name: data.name,
        description: data.description,
        price: data.price,
        weight: data.weight
      });
    },
    getDish(idDish) {
      return instance.get(`/api/cafe/dishes/admin/${idDish}/`);
    },
    updateDish(idDish, data) {
      return instance.put(`/api/cafe/dishes/admin/${idDish}/`, {
        name: data.name,
        description: data.description,
        price: data.price,
        weight: data.weight
      });
    },
    deleteDish(idDish) {
      return instance.delete(`/api/cafe/dishes/admin/${idDish}/`);
    },
    updateImageProduct(idDish, data) {
      let formData = new FormData();
      formData.append("image", data.imageFile);

      return instance.put(`/api/cafe/dishes/admin/${idDish}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },

    getOrders(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/cafe/orders/admin/", { params: data });
    },
    getOrder(idOrder) {
      return instance.get(`/api/cafe/orders/admin/${idOrder}/`);
    },
    updateOrderStatus(idOrder) {
      return instance.put(`/api/cafe/orders/admin/${idOrder}/`, {
        is_delivered: true
      });
    },
    deleteOrder(idOrder) {
      return instance.delete(`/api/cafe/orders/admin/${idOrder}/`);
    }
  };
}
